# Used by onboarding
# Once a DIS request has been created, the application polls the server
# repeatedly to verify its status. Once the request has been acknowledged,
# the behaviour directs the user to appropriate DIS UI.

redirect = (url) ->
  window.location = url

state_machine = (instance) ->
  status_endpoint = $(instance).data('status-endpoint')
  providers_endpoint = $(instance).data('providers-endpoint')
  create_endpoint = $(instance).data('create-endpoint')
  timeout = 1000 # ms
  pollProvidersTimeoutId = null

  $busy = $(instance).children('.busy')
  $chooser = $(instance).children('.chooser')
  $providers = $(instance).find('ul.providers')
  $chooseButton = $chooser.find('button.choose')
  $radioButton = $chooser.find('input[name="provider_name"]')
  $chooseButton = $chooser.find('button.choose')

  $providerTerms = $chooser.find('.accept-provider-terms')
  $providerTermsCheckBox = $providerTerms.find('#accept-provider-terms')

  $openingHoursNotice = $(instance).find('.dis-opening-hours-notice')

  $radioButton.on 'change', ->
    value = $radioButton.filter(":checked").val()

    if value == 'fidentity'
      $providerTerms = $(instance).find('.accept-provider-terms')
      $providerTerms.removeClass('hidden')
      $chooseButton.prop('disabled', !$providerTermsCheckBox.is(':checked'))
      $providerTermsCheckBox.on 'change', ->
        $chooseButton.prop('disabled', !$(this).is(':checked'))
    else
      $providerTerms.addClass('hidden')
      $chooseButton.prop('disabled', !value)

  do pollStatus = ->
    $.getJSON(status_endpoint)
    .done( (response, status, xhr) ->
      if response.state == 'pending' || response.state == 'callback'
        # poll aStatusgain in x seconds, waiting for updates
        setTimeout(pollStatus, timeout)
      else if response.state == 'ready'
        # show link once ready, just in case the redirect is blocked
        redirect_link = $(instance).find('a.redirect-link')
        redirect_link.attr('href', response.remote_url)
        redirect_link.removeClass('hidden')

        # redirect, once ready
        redirect(response.remote_url)
      else
        # redirect to show error / success message
        # (also gets here when in review or reviewed state, see VAB-614)
        setTimeout((-> redirect(window.location.href)), 1500)
    )
    .fail( (xhr, status, err) ->
      if xhr.status == 404
        # DIS not created yet
        pollProvidersFirstTime = true

        do pollProviders = ->
          $.getJSON(providers_endpoint)
          .done( (response, status, xhr) ->
            for provider in response
              $provider = $chooser.find('.provider[data-provider="' + provider.name + '"]')

              if provider.open
                $provider.removeClass('closed').addClass('open')
              else
                $provider.removeClass('open').addClass('closed')

              if provider.available
                $provider.removeClass('unavailable').addClass('available')
              else
                $provider.removeClass('available').addClass('unavailable')

            # Show opening hours notice if no providers are available
            if $providers.children('.available').length == 0
              $openingHoursNotice.removeClass('hidden')
            else
              $openingHoursNotice.addClass('hidden')

            # if we poll the providers for the first time, make sure
            # to hide the spinner and show the provider palette, doing it this
            # way avoids flickering.
            if pollProvidersFirstTime
              $busy.css('display', 'none')
              $chooser.css('display', 'block')
              pollProvidersFirstTime = false
              firstAvailable = $providers.children('.available:first').data('provider')
              # select preferred provider if available
              $radioButton.val([firstAvailable]).change() if firstAvailable

            pollProvidersTimeoutId = setTimeout(pollProviders, 10*1000)
          )
          .fail( (xhr, status, err) ->
            if xhr.status == 401
              window.location.reload()
            else
              console.log("Error polling providers: ", status, err)
              pollProvidersTimeoutId = setTimeout(pollProviders, 10*1000)
          )
      else if xhr.status == 401
        # waited too long, show re-entry screen by reloading website
        window.location.reload()
      else
        console.log("Error polling DIS status: ", status, err)
        setTimeout(pollStatus, timeout)
    )

  $chooseButton.on 'click', ->
    provider_name = $radioButton.filter(":checked").val()
    return unless provider_name

    clearTimeout(pollProvidersTimeoutId)
    $busy.css('display', 'block')
    $chooser.css('display', 'none')
    $.post(create_endpoint, { provider_name: provider_name }, 'json')
    .done( (response, status, xhr) ->
      pollStatus()
    )
    .fail( (xhr, status, err) ->
      console.log("Error creating DIS request: ", status, err)
      pollStatus()
    )

$ ->
  $('[data-behaviour=dis-state-machine]').each -> state_machine(this)
